const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

class PriceGuidePaginationButton extends React.Component {
  static propTypes = {
    links: PropTypes.object.isRequired,
    link: PropTypes.string.isRequired,
    followPagination: PropTypes.func.isRequired,
    direction: PropTypes.string.isRequired,
  };

  render() {
    if (this.props.links && this.props.links[this.props.link]) {
      return (
        <button className={classNames('button button--mini button--offwhite', this.props.link)} onClick={this.props.followPagination(this.props.links[this.props.link].href)}>
          <span className={`fa fa-chevron-${this.props.direction}`} />
        </button>
      );
    } else {
      return (
        <button className={classNames('button button--mini button--offwhite ml-half', this.props.link)} disabled="disabled">
          <span className={`fa fa-chevron-${this.props.direction}`} />
        </button>
      );
    }
  }
}

module.exports = PriceGuidePaginationButton;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/price_guide_pagination_button.jsx